import templateUrl from './pending-payrolls.component.html'
import './pending-payrolls.component.less'

export const DashboardPendingPayrollsComponent = {
    bindings: {
        page: "<pendingPayrolls",
        dismiss: "&onDismiss",
        changePage: "&onChangePage"
    },
    controller: class DashboardPendingPayrolls {
        constructor() {
            this.pageNumber = 1
        }

        $onInit() {
            this.setUpdatedPageProperties(this.page);
        }
        $onChanges(changesObj) {
            if (changesObj.page) {
                this.setUpdatedPageProperties(this.page);
            }
        }
        setUpdatedPageProperties(page) {
            this.pageNumber = page.PageIndex + 1;
            this.pageSize = page.PageSize + 1;
            this.pendingPayrolls = page.Entities;
            this.totalEntityCount = page.TotalEntityCount
        }

    },
    controllerAs: "vm",
    templateUrl
}
